import React from 'react';
import { Layout, SEO } from 'components/common';
import { Krone } from 'components/landing/Krone';

export default () => (
  <Layout>
    <SEO />
    <Krone/>
  </Layout>
);
